import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourDetailsMain from '../Components/Tour/TourDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { api } from '../services/api'
import { usePageBanner } from '../hooks/usePageBanner'

function TourDetails() {
    const { id } = useParams()
    const { title, bgImage } = usePageBanner({
        itemLoader: api.getTour,
        itemId: id,
        fallbackTitle: 'Tour Details',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <TourDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default TourDetails
